import React from 'react'

export default function UnavailablePage() {
  return (
        <div className="d-flex align-items-center justify-content-center vh-50">
            <div className="text-center">
                <h1 className="display-1 fw-bold">404</h1>
                <p className="fs-3"> <span className="text-danger">Oops!</span> Something's gone wrong </p>
                <p className="lead">
                    Contact Casey to see wtf be goin on
                    </p>
            </div>
        </div>  
    )
}
